import { Button, Divider, Flex } from "monday-ui-react-core";
import React from "react";
import styled from "styled-components";

import CloneProgressLine from "@/components/CloneReport/components/CloneProgressLine";
import ProgressIndicatorHeader from "@/components/CloneReport/components/ProgressIndicatorHeader";
import { clonePlusDialog } from "@/lib/monday";

export interface CloneReportProps {
  bulkCloneCount: number;
  results: { status: string; label: string }[];
  isProcessFailed: boolean;
  noOfTries: number;
  duration?: number;
}

const BulkReportSection = styled.div`
  font-family: var(--font-family);
  flex-shrink: 2;
  width: 100%;
  margin-right: 20px;
  .spe-line {
    margin-top: 44px;
    border: 2px solid #dfe1e6;
  }
  .footer-sec {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .help-sec {
    margin-top: 54px;
    .header {
      font-family: inherit;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      color: var(--primary-text-color);
    }
    .desc {
      margin-top: 18px;
    }
  }
`;

const SectionMessage = styled.div`
  font-family: var(--font-family);
`;

export default function CloneReport({ bulkCloneCount, results, isProcessFailed, noOfTries }: CloneReportProps) {
  const onViewClone = () => {
    clonePlusDialog.closeModalDialog({ dataJson: JSON.stringify({ redirectToTargetBoard: true, retryAgain: false }) });
  };

  const onClose = () => {
    clonePlusDialog.closeModalDialog();
  };

  const onTryAgain = () => {
    // TODO: fix me MNI
  };

  const getProgressbarBody = () => {
    let _body = null;
    if (results.length && !isProcessFailed) {
      _body = results.map(
        (field) => field.label && <CloneProgressLine key={field.label} status={field.status} label={field.label} />
      );
    } else if (isProcessFailed) {
      _body = (
        <SectionMessage>
          <p>Clone Plus - Copy Items is currently unable to handle this request. Please try again after some time.</p>
        </SectionMessage>
      );
    }
    return _body;
  };
  const getFooter = () => {
    const isViewClonesEnabled = bulkCloneCount > 0;
    let footer = results.length ? (
      <Flex gap={Flex.gaps.SMALL} justify={Flex.justify.END} style={{ width: "100%" }}>
        <Button disabled={!isViewClonesEnabled} onClick={onViewClone}>
          View clone(s)
        </Button>
        <Button kind={Button.kinds.TERTIARY} onClick={onClose}>
          Close
        </Button>
      </Flex>
    ) : (
      <div />
    );
    if (isProcessFailed) {
      footer = (
        <Flex gap={Flex.gaps.SMALL} justify={Flex.justify.START} style={{ width: "100%" }}>
          <Button style={{ visibility: noOfTries < 5 ? "visible" : "hidden" }} onClick={onTryAgain}>
            Try again
          </Button>
          <Button kind={Button.kinds.TERTIARY} onClick={onClose}>
            Cancel
          </Button>
        </Flex>
      );
    }
    return footer;
  };

  return (
    <div id="page" style={{ padding: "48px 28px 0" }}>
      <BulkReportSection>
        <ProgressIndicatorHeader />
        <header className="help-sec" style={{ marginTop: "10px", marginBottom: "5px" }}>
          <div className="header">Clone Report</div>
        </header>
        <p style={{ marginTop: "0px", marginBottom: "24px" }}>
          <b>{`${bulkCloneCount}`} </b>
          {" items cloned"}
        </p>
        {getProgressbarBody()}
        <Divider className="spe-line" />
        <div id="footer" className="footer-sec">
          {getFooter()}
        </div>
      </BulkReportSection>
    </div>
  );
}
